import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SelectionService {
	private selectedIds = new Set<string>();
	selectionChanged = new EventEmitter<Set<string>>();

	toggle(id: string): void {
		if (this.selectedIds.has(id)) {
			this.selectedIds.delete(id);
		} else {
			this.selectedIds.add(id);
		}
		this.selectionChanged.emit(this.selectedIds);
	}

	add(ids: string[]): void {
		ids.forEach(id => this.selectedIds.add(id));
		this.selectionChanged.emit(this.selectedIds);
	}

	remove(id: string): void {
		this.selectedIds.delete(id);
		this.selectionChanged.emit(this.selectedIds);
	}

	removeMultiple(ids: string[]): void {
		ids.forEach(id => this.selectedIds.delete(id));
		this.selectionChanged.emit(this.selectedIds);
	}

	clear(): void {
		this.selectedIds.clear();
		this.selectionChanged.emit(this.selectedIds);
	}

	isSelected(id: string): boolean {
		return this.selectedIds.has(id);
	}

	getSelection(): Set<string> {
		return new Set(this.selectedIds);
	}

	getSelectionArray(): string[] {
		return Array.from(this.selectedIds);
	}

	count(): number {
		return this.selectedIds.size;
	}
}
